export type HeaderState = boolean;

export const headerInitialState: HeaderState = false;
